import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useState, useRef, useMemo } from 'react';
import { SyncEngine } from './sync-engine';
import { setupSyncTriggers } from './sync-triggers';
const SyncContext = createContext(null);
export function useSync() {
    const ctx = useContext(SyncContext);
    if (!ctx)
        throw new Error('useSync must be used within SyncProvider');
    return ctx;
}
export function useSyncOptional() {
    return useContext(SyncContext);
}
export function SyncProvider({ children, enabled, onDataChanged, }) {
    const engineRef = useRef(null);
    if (!engineRef.current) {
        engineRef.current = new SyncEngine();
    }
    const engine = engineRef.current;
    const [status, setStatus] = useState(engine.getStatus());
    useEffect(() => {
        const unsub = engine.subscribe(setStatus);
        return unsub;
    }, [engine]);
    useEffect(() => {
        engine.setOnDataChanged(onDataChanged ?? null);
        return () => engine.setOnDataChanged(null);
    }, [engine, onDataChanged]);
    useEffect(() => {
        if (!enabled)
            return;
        const cleanup = setupSyncTriggers(engine);
        // Initial sync on mount
        engine.triggerSync();
        return cleanup;
    }, [engine, enabled]);
    const value = useMemo(() => ({
        status,
        triggerSync: () => engine.triggerSync(),
        fetchConflicts: () => engine.fetchConflicts(),
        resolveConflict: (entityType, entityId, choice) => engine.resolveConflict(entityType, entityId, choice),
        engine,
    }), [status, engine]);
    return _jsx(SyncContext.Provider, { value: value, children: children });
}
